<ion-grid>
  <ion-row class="padding-top">
    <ion-col *ngIf="leaderboard.puzzleHasLeaderboardEntry$ | async">
      <ion-button
        class="tab-button"
        [fill]="mode === 'my_context' ? 'solid' : 'outline'"
        (click)="changeMode('my_context');"
        size="small"
      >
        {{ "PUZZLE.leaderboard.tab_my_context.button" | translate }}
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button
        class="tab-button"
        [fill]="mode === 'topn_strict' ? 'solid' : 'outline'"
        (click)="changeMode('topn_strict');"
        size="small"
      >
        {{ "PUZZLE.leaderboard.tab_topn_strict.button" | translate }}
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button
        class="tab-button"
        [fill]="mode === 'topn_relaxed' ? 'solid' : 'outline'"
        (click)="changeMode('topn_relaxed');"
        size="small"
      >
        {{ "PUZZLE.leaderboard.tab_topn_relaxed.button" | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row class="scrollable">
    <ion-col>
      <h1>{{ "PUZZLE.leaderboard.tab_" + mode + ".title" | translate : { topN: topN } }}</h1>
      <p>{{ "PUZZLE.leaderboard.tab_" + mode + ".message_submitted" | translate : { leaderboardTimeLocal: leaderboardTimeLocal, leaderboardDateLocal: leaderboardDateLocal } }}</p>
      <table>
        <tr>
          <th class="lb-placement">
            {{ 'PUZZLE.leaderboard.table_title_rank' | translate }}
          </th>
          <th class=lb-time>
            {{ 'PUZZLE.leaderboard.table_title_time' | translate }}
          </th>
          <th class=lb-name>
            {{ 'PUZZLE.leaderboard.table_title_name' | translate }}
          </th>
          <th *ngIf="mode === 'topn_relaxed' || (mode === 'my_context' && !strictRules)" class=lb-helpers>
            {{ 'PUZZLE.leaderboard.table_title_helpers' | translate }}
          </th>
        </tr>
        <tr
          class=lb-top
          [class.lb-winner]="mode === 'my_context' && entry !== 'gap' && (leaderboard.leaderboardContext$|async)?.entryPosition === entry.rank"
          [class.lb-ellipsis]="entry==='gap'"
          *ngFor="let entry of leaderboardEntries[mode]; index as i"
        >
          <ng-container *ngIf="entry !== 'gap'; else gap">
            <td class="lb-placement">{{ entry.rank }}.</td>
            <td class=lb-time>{{ entry.timePlayed | timeFromMS }}</td>
            <td class=lb-name>
              <!-- Unfiltered name if this is my name or if it is not flagged as profane. -->
              <ng-container
                *ngIf="(leaderboard.leaderboardContext$|async)?.entryPosition === entry.rank || !entry.profanity"
              >
                {{ entry.nickname }}
              </ng-container>
              <!-- Filtered name if this is not my name and it is flagged as profane. -->
              <ng-container
                *ngIf="(leaderboard.leaderboardContext$|async)?.entryPosition !== entry.rank && entry.profanity"
              >
                {{ entry.nickname | badwordsNickname | async }}
              </ng-container>
              <!-- Report link always, unless it is my own name. -->
              <span
                *ngIf="(leaderboard.leaderboardContext$|async)?.entryPosition !== entry.rank"
                class="report-link"
                (click)="reportNickname(entry, $event)"
                [tooltip]="'PUZZLE.leaderboard.report.tooltip' | translate"
              >
                ({{ 'PUZZLE.leaderboard.report.report' | translate }})
              </span>
            </td>
            <td class=lb-helpers *ngIf="mode === 'topn_relaxed' || (mode === 'my_context' && !strictRules)">
              <ng-container *ngFor="let helper of entry.helpersUsed">
                <span
                  slot="end"
                  tooltip="{{ 'PUZZLE.leaderboard.helper_icon_' + helper | translate }}"
                >
                  <ion-icon
                    *ngIf="helper === 'pause'"
                    name="pause-circle-outline"
                    slot="icon-only" size="small"
                  />
                  <ion-icon
                    *ngIf="helper === 'check'"
                    name="checkmark-sharp"
                    slot="icon-only"
                    size="small"
                  />
                  <ion-icon
                    *ngIf="helper === 'highlight_right_and_wrong'"
                    name="spellcheck"
                    slot="icon-only"
                    size="small"
                  />
                  <ion-icon
                    *ngIf="helper === 'joker'"
                    name="color-wand-sharp"
                    slot="icon-only"
                    size="small"
                  />
                </span>
              </ng-container>
            </td>
          </ng-container>
          <ng-template #gap>
            <td class="lb-placement">...</td>
            <td class=lb-time>...</td>
            <td class=lb-name>...</td>
            <td class=lb-helpers *ngIf="!strictRules">...</td>
          </ng-template>
        </tr>
      </table>
      <p *ngIf="withMessage && mode === 'topn_strict' &&  leaderboardEntries[mode]?.length > 0">{{ "PUZZLE.leaderboard.message_strict" | translate }}</p>
      <p *ngIf="withMessage && mode === 'topn_relaxed' && leaderboardEntries[mode]?.length > 0">{{ "PUZZLE.leaderboard.message_relaxed" | translate }}</p>
      <p *ngIf="!smallProgress && leaderboardEntries[mode]?.length === 0">{{ "PUZZLE.leaderboard.message_empty" | translate }}</p>
      <p *ngIf="smallProgress">
        {{ 'PUZZLE.leaderboard.wait_update' | translate }}
      </p>
    </ion-col>
  </ion-row>
</ion-grid>
